import React from "react";

function Home() {
  return (
    <div className="text-center p-10">
      <h2 className="text-4xl font-bold text-blue-900 mb-4">Welcome to Seafood Delight</h2>
      <p className="text-lg">Fresh seafood straight from the ocean to your plate.</p>
       <img 
        src="https://images.unsplash.com/photo-1504674900247-0877df9cc836"
        alt="Seafood platter"
        style={{ marginTop: "20px", borderRadius: "10px", maxWidth: "80%" }}
      />
    </div>
  );
}

export default Home;
